import React, { useState, useEffect } from 'react'
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { HTTP } from '../../../api/resources'
import { DirectUpload } from '@rails/activestorage';
import TextEditor from '../../Helpers/Utilities/TextEditor';


export default function Form(props) {
    const [blog, setBlog] = useState(props.blog)
    const [image, setImage] = useState(null)
    const [dirty, setDirty] = useState(false)
    const [saving, setSaving] = useState(false)
    const [categories, setCatergories] = useState(props.categories)
    const [selectedCategory, setSelectedCategory] = useState(categories[0])
    const [option, setOptions] = useState([
        {id: 1, name: "Blog"},
        {id: 2, name: "Knowledge"},
        {id: 3, name: "Customer Posts"},
        {id: 4, name: "Product Updates"}
    ])
    const [selectedOption, setSelectedOption] = useState(option[0])
    const [fileUploading, setFileUploading] = useState(false)

    useEffect(() => {
        if (blog.category_id) {
            setSelectedCategory(categories.map(c => {
                if (blog.category_id == c.id) return c
            }))
        } else {
            setBlog({...blog, category_id: selectedCategory.id})
        }

        if (blog.article_type) {
            setSelectedOption(option.map(opt => {
                if (blog.article_type.replace('_', ' ') == opt.name.toLowerCase()) {
                    return opt
                }
            }))
        }
    }, [])

    // Image upload
    const hiddenFileInput = React.useRef(null);

    const handleClick = (event) => {
        hiddenFileInput.current.click();
    }

    const handleChange = (event) => {
        setDirty(true)
        const files = event.target.files;
        // upload only the first file
        uploadFile(files[0])
    }

    const uploadFile = (file) => {
        setFileUploading(true)
        const upload = new DirectUpload(file, '/api/v1/direct_uploads');
        upload.create((error, blob) => {
          if (error) {
            // Handle the error
            Alert.show("error", "Could not update. Try again.");
            setFileUploading(false)
          } else {
            setTimeout(() => { setFileUploading(false) }, 5000);
            let image = blob
            setImage(image.signed_id)
            Alert.show('notice', 'Image has been added')
          }
        })
    }

    // Creation and Update
    const validate = async () => {
        if (!blog.title || !blog.body || !blog.published_date || !blog.category_id || !blog.article_type) {
            Alert.show('notice', 'Fill all the required fields')
            return
        }

        setSaving(true)

        let data = {
            blog: blog
        }

        if (image) data.blog.image = image

        if (!props.new) {
            try {
                await updateBlog(data)
            } catch {
                // return
            }

            setSaving(false)
            Alert.show('notice', 'Post updated successfully')
            return
        }


        try {
            await newBlog({blog})
        } catch {
            Alert.show('error', 'Error processing request')
            return
        }

        setSaving(false)
        Alert.show('notice', 'Post created successfully')
    }

    const newBlog = (data) => {
        return HTTP.post('/blog', data)
    }

    const updateBlog = (data) => {
        return HTTP.patch(`/blog/${data.blog.id}`, data)
    }

    const deleteBlog = async () => {
        try {
            await deleteRoute(data)
        } catch {
            Alert.show('error', 'Error deleting article')
            return
        }

        Alert.show('notice', 'Deleted')
        window.location = '/blog'
    }

    const deleteRoute = (data) => {
        return HTTP.delete(`/blog/${data.blog.id}`)
    }

  return (
    <div>
        <div className="">
            <div class="d-flex align-items-center justify-content-end">
                <div>
                    <a className="btn btn-bg btn-outline-danger mr-1" href="/blog">Cancel</a>
                    <button className="btn btn-primary" onClick={validate}>
                        {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                        Save
                    </button>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <label htmlFor="title">Title (maximum 40 characters)</label>
                    <input className="form-control" placeholder="Title" type="text" name="title" id="title"
                    value={blog.title}
                    onChange={e => {
                        setBlog({...blog, title: e.target.value})
                        setDirty(true)
                    }}
                    />
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <label htmlFor="title">Body</label>
                    <TextEditor value={blog.body} returnChange={(arg) => setBlog({...blog, body: arg})}/>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <label htmlFor="title">Tag</label>
                    <input className="form-control" placeholder="Tag" type="text" name="title" id="title"
                    value={blog.tag}
                    onChange={e => {
                        setBlog({...blog, tag: e.target.value})
                        setDirty(true)
                    }}
                    />
                </div>
            </div>

            <div className="col-md-6">
                <div className="form-group">
                    <label htmlFor="title">Time</label>
                    <input className="form-control" placeholder="5 minutes read" type="text" name="title" id="title"
                    value={blog.time}
                    onChange={e => {
                        setBlog({...blog, time: e.target.value})
                        setDirty(true)
                    }}
                    />
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <label htmlFor="title">Author</label>
                    <input className="form-control" placeholder="Author name" type="text" name="title" id="title"
                    value={blog.author}
                    onChange={e => {
                        setBlog({...blog, author: e.target.value})
                        setDirty(true)
                    }}
                    />
                </div>
            </div>

            <div className="col-md-6">
                <div className="form-group">
                    <label htmlFor="published_on">Published date</label>
                    <Flatpickr className="form-control"
                    value={blog.published_date}
                    onChange={(date, dateStr) => {
                        setBlog({...blog, published_date: dateStr})
                        setDirty(true)
                    }}
                    />
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-md-6">
                <div className="form-group" role="group" aria-labelledby="postAsLabel">
                    <label id="postAsLabel">Category</label>
                    <div className="input-group">
                        <Select
                            className="w-100"
                            onChange={(value) => {
                            setDirty(true)
                            setSelectedCategory(value)
                            setBlog({...blog, category_id: value.id})
                            }}
                            options={categories}
                            getOptionLabel={(category) =>
                            `${category.name}`
                            }
                            getOptionValue={(category) => category.id}
                            value={selectedCategory}
                        />
                    </div>
                </div>
            </div>

            <div className="col-md-6">
                <div className="form-group" role="group" aria-labelledby="postAsLabel">
                    <label id="postAsLabel">Resource type</label>
                    <div className="input-group">
                        <Select
                            className="w-100"
                            onChange={(resource) => {
                            setDirty(true)
                            setSelectedOption(resource)
                            setBlog({...blog, article_type: resource.name.toLowerCase().replace(' ', '_')})
                            }}
                            options={option}
                            getOptionLabel={(resource) =>
                            `${resource.name}`
                            }
                            getOptionValue={(resource) => resource.id}
                            value={selectedOption}
                        />
                    </div>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-md-6">
                    <div className="form-group">
                        <label htmlFor="profile_image">Image</label>
                    <div id="profile_image" className="d-flex align-items-center">
                        <button onClick={handleClick} className="btn btn-primary">
                            {fileUploading && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                            Upload Image
                        </button>
                    </div>
                    <div>
                        <small className="text-muted">Supported formats: .jpg/jpeg, .png, .pdf, .doc, .docx</small>
                    </div>
                    <input
                        type="file"
                        ref={hiddenFileInput}
                        style={{ display: "none" }}
                        onChange={handleChange}
                     />
                </div>
            </div>
        </div>
    </div>
  )
}
